import { Ordrebekreftelse, ProduktSpesifikasjon } from "codegen";
import { format } from "date-fns";
import { Link } from "react-router-dom";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import { Table } from "components/organisms/Table";

export const noneOrderConfirmation: Ordrebekreftelse = { id: "ingen", navn: "Ingen ordrebekreftelse" };

export default function ProductsPage({
	products,
	orderConfirmations,
}: {
	readonly products: ProduktSpesifikasjon[];
	readonly orderConfirmations: Ordrebekreftelse[];
}) {
	return (
		<Flex gap="2rem" direction={Direction.column}>
			<MainLayoutPageHeader title="Produktadmin" />
			<h2>Alle produktbeskrivelser for strømavtalene våre</h2>
			<Table
				// Liten hack for å fikse sortering på oppdatert kolonnen
				entries={products.map((p) => {
					return { ...p, oppdatert: p.updated?.at };
				})}
				labels={{ tariffId: "Tariff-ID", navn: "UC Produkt", ordrebekreftelse: "Ordrebekreftelse", oppdatert: "Sist oppdatert" }}
				generators={{
					tariffId: (p: ProduktSpesifikasjon) => (
						<Link to={`/products/${p.tariffId}`} title="Se eller endre produkt">
							{p.tariffId}
						</Link>
					),
					navn: (p: ProduktSpesifikasjon) => <p>{p.navn ? p.navn : "Ikke satt"}</p>,
					ordrebekreftelse: (p: ProduktSpesifikasjon) => (
						<>
							{(p.ordrebekreftelse === noneOrderConfirmation?.id && <>{noneOrderConfirmation?.navn}</>) || (
								<Link to={`/products/order-confirmations/${p.ordrebekreftelse}?tariffId=${p.tariffId}`} title="Se ordrebekreftelse">
									{orderConfirmations.find((c) => c.id === p.ordrebekreftelse)?.navn}
								</Link>
							)}
						</>
					),
					oppdatert: (p: ProduktSpesifikasjon) => (
						<>{p.updated?.name && p.updated?.at && `${format(new Date(p.updated?.at), "dd.MM.yyyy")} - ${p.updated?.name}`}</>
					),
				}}
				action={(p: ProduktSpesifikasjon) => (
					<Link to={`/products/${p.tariffId}`} title="Se eller endre produkt">
						<FontAwesomeIcon icon={faPencil} />
					</Link>
				)}
			/>
		</Flex>
	);
}
